module.exports = __webpack_public_path__ + "img/gift7-01-c1.c9802e7c.png";